import React, { useState, useEffect, useRef } from 'react';
import styles from './LiveTVModal.module.css';
import { X } from 'lucide-react';

const LiveTVModal = ({ url, onClose }) => {

  console.log("url", url)
  // Center initial position
  const [position, setPosition] = useState({ x: window.innerWidth / 2 - 200, y: window.innerHeight / 2 - 150 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const modalRef = useRef(null);

  const handleMouseDown = (e) => {
    // Only drag from header
    setIsDragging(true);
    dragStart.current = { x: e.clientX - position.x, y: e.clientY - position.y };
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging) {
        setPosition({
          x: e.clientX - dragStart.current.x,
          y: e.clientY - dragStart.current.y
        });
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  // if (!url) return null; // Render modal even if no URL to show feedback

  return (
    <div 
      className={styles.modalOverlay}
      style={{ left: position.x, top: position.y }}
      ref={modalRef}
    >
      <div 
        className={styles.modalHeader}
        onMouseDown={handleMouseDown}
      >
        <span className={styles.dragText}>⋮⋮</span>
        <button className={styles.closeButton} onClick={onClose}>
          <X size={16} />
        </button>
      </div>
      <div className={styles.modalContent}>
        {url ? (
          <iframe
            src={url}
            title="Live TV"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
            className={styles.iframe}
          />
        ) : (
          <div style={{
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%', 
            color: '#888',
            fontSize: '14px'
          }}>
            No Live Stream Available
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveTVModal;
